import type { FloorFallView } from "./models"

export const isExteriorFloorFall = (view?: FloorFallView): boolean =>
    view?.exterior === true && view.phase !== "landed"

/** Body height relative to the current destination floor, in world pixels. */
export const floorFallOffsetAt = (view: FloorFallView, elapsedMs: number): number => {
    if (!view.trajectory || view.phase === "landed") return 0
    const { gravity, distanceBefore, endElapsedMs, totalDistance } = view.trajectory
    const elapsed = Math.max(0, view.phase === "falling" && totalDistance !== undefined
        ? elapsedMs : Math.min(endElapsedMs, elapsedMs))
    // During a delayed room snapshot the already streamed lower floors remain in
    // view. Continue through them, but never extrapolate beyond supported ground.
    const fallen = Math.min(totalDistance ?? distanceBefore + view.distance, gravity * elapsed * elapsed / 2)
    return fallen - distanceBefore - view.distance
}
